import { NgForOf, NgIf } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { PushPipe } from '@ngrx/component';

import { HelpArticlesDirective } from '@recruitee/help-articles';
import { ButtonComponent, DialogBodyComponent, HeadingComponent } from '@recruitee/user-interface';

import { TutorialTranslations } from './translations';
import { TutorialDialogNavComponent } from './tutorial-dialog-nav/tutorial-dialog-nav.component';
import { TutorialDialogComponent } from './tutorial-dialog.component';
import { ASSETS_PROVIDER, AssetsProvider } from './tutorial-dialog.types';

@NgModule({
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    HeadingComponent,
    HelpArticlesDirective,
    NgIf,
    NgForOf,
    PushPipe,
  ],
  declarations: [TutorialDialogComponent, TutorialDialogNavComponent],
  exports: [TutorialDialogComponent, TutorialDialogNavComponent],
})
export class TutorialDialogModule {
  public static withProviders(
    translations: any,
    assetsProvider: AssetsProvider,
  ): ModuleWithProviders<TutorialDialogModule> {
    return {
      ngModule: TutorialDialogModule,
      providers: [
        { provide: TutorialTranslations, useValue: translations },
        { provide: ASSETS_PROVIDER, useValue: assetsProvider },
      ],
    };
  }
}

export * from './tutorial-dialog-nav/tutorial-dialog-nav.component';
export * from './tutorial-dialog.component';
export * from './tutorial-dialog.service';
